import { axiosSwagger } from "@/axios";

export const state = {
}


export const getters = {
}


export const mutations = {
}


export const actions = {
    // FILE POSTING
    // eslint-disable-next-line no-unused-vars
    async readFilePostingByFileManagerId({ commit }, id) {
        return await axiosSwagger
        .get(`/api/FilePosting/FileManager/${id}`)
        .then((response) => {

            return response;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async createFilePosting({ commit }, data) {
        return await axiosSwagger
        .post("/api/FilePosting/Create", data)
        .then((response) => {

            return response;
        });
    }
}